import request from '@/axios'

// 获取字典列表
export const getDictionaryList = (params: any) => {
  return request.get({ url: '/system/dict/type/list', params })
}

// 新增字典
export const addDictionary = (data: any) => {
  return request.post({ url: '/system/dict/type', data })
}

// 修改字典
export const updateDictionary = (data: any) => {
  return request.put({ url: '/system/dict/type', data })
}

// 删除字典
export const deleteDictionary = (dictIds: string) => {
  return request.delete({ url: `/system/dict/type/${dictIds}` })
}

// 获取字典详情
export const getDictionaryDetail = (dictId: number) => {
  return request.get({ url: `/system/dict/type/${dictId}` })
}

// 获取字典选择框列表
export const getDictionarySelectList = () => {
  return request.get({ url: '/system/dict/type/optionselect' })
}

// 获取字典数据列表
export const getDictionaryDataList = (params: any) => {
  return request.get({ url: '/system/dict/data/list', params })
}

// 删除字典数据
export const deleteDictionaryData = (dictIds: string) => {
  return request.delete({ url: `/system/dict/data/${dictIds}` })
}

// 新增字典数据
export const addDictionaryData = (data: any) => {
  return request.post({ url: '/system/dict/data', data })
}

// 修改字典数据
export const updateDictionaryData = (data: any) => {
  return request.put({ url: '/system/dict/data', data })
}

// 获取字典数据详情
export const getDictionaryDataDetail = (dictId: number) => {
  return request.get({ url: `/system/dict/data/${dictId}` })
}

// 获取字典数据选择框列表
export const getDictionaryDataSelectList = (dictType: string) => {
  return request.get({ url: `/system/dict/data/type/${dictType}` })
}

// 批量获取字典数据选择框列表
export const getDictionaryDataMultiSelectList = (dictTypes: string) => {
  return request.get({ url: `/system/dict/data/type/list/${dictTypes}` })
}

// 导出字典列表
export const exportDictionaryList = () => {
  return request.post({ url: '/system/dict/type/export', responseType: 'blob' })
}
